// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","toasts":"Toasts_toasts__XwEM0"};